"use client";
import { usePathname } from "next/navigation";

export default function Marquee() {
  const pathname = usePathname();
  if (pathname !== "/") return null;

  const text = "SMART PLANNING - STRONG EXECUTION - SUSTAINABLE RESULTS.";

  return (
    <div className="marquee border-t border-cyan-100/80">
      <div className="marquee-track text-slate-500">
        <span>{text}</span>
        <span>{text}</span>
        <span>{text}</span> {/* extra copy prevents gap */}
      </div>
    </div>
  );
}
